<div class="popup-msg-content">
    <h1>{{languageEditorCtrl.header || 'language.editor.title'|translate}}</h1>
    <c-language-editor-tree items="languageEditorCtrl.itemsCopy" languages="languageEditorCtrl.languages" type="languageEditorCtrl.type" use-position="true" rows="{{languageEditorCtrl.rows}}" editor="languageEditorCtrl.editor" properties="languageEditorCtrl.properties"></c-language-editor-tree>
</div>
<div class="popup-button-content">
    <div>
        <span><button class="popup-msg-button btn-primary" ng-click="languageEditorCtrl.save()"><span>{{'popup.ok'|translate}}</span></button></span>
        <span><button id="cancel" class="popup-msg-button" ng-click="languageEditorCtrl.cancel()"><span>{{'popup.cancel'|translate}}</span></button></span>
    </div>
</div>
